interface IFileDTO {
    lastModified: number;
    lastModifiedDate: Date;
    name: string;
    path: string;
    preview: string;
    size: number;
    type: string;
    webkitRelativePath: string;
    file: any[] | any;
}

export const convertIFileDTOToFile = (fileDto: IFileDTO): File & { preview: string } => {
	const byteCharacters = atob(fileDto.file);
	const byteNumbers = new Array(byteCharacters.length);
	for (let i = 0; i < byteCharacters.length; i+=1) {
		byteNumbers[i] = byteCharacters.charCodeAt(i);
	}
	const byteArray = new Uint8Array(byteNumbers);
	const file = new File([byteArray], fileDto.name, { type: fileDto.type, lastModified: new Date(fileDto.lastModifiedDate).getTime() });	
	return Object.assign(file, {
		preview: URL.createObjectURL(file)
	});
};

export const convertIFileDTOArrayToFileArray = (fileDtoArray: IFileDTO[]): File[] => {
	const File: File[] = [];
	fileDtoArray.forEach((fileDto) => {
		const IFileNode = convertIFileDTOToFile(fileDto);
		File.push(IFileNode);
	});
	return File;
};

export default IFileDTO;
